import { h } from '../utils'

interface DescriptionFieldOptions {
  html: string
  name: string
  hidden?: boolean
}

export function descriptionField(options: DescriptionFieldOptions) {
  // Text
  const text = h('div', { class: 'vbzc-prose vbzc-prose-sm' }, { html: options.html })

  // Field
  const field = h(
    'div',
    { 'class': 'vbzc-field' + (options.hidden ? ' vbzc-field-hidden' : ''), 'data-name': options.name },
    { children: [text] },
  ) as HTMLDivElement

  return { field }
}
